<script>
import VsAlert from 'viralstyle-ui/src/VsAlert';
import VsContainer from 'viralstyle-ui/src/VsContainer';
import { mapState } from 'vuex';

import clientMixins from 'utils/client-mixins';
import { privileges } from 'domains/base/_base-enum';
import { seoValidator } from '../_campaigns-validator';

export default {
  components: {
    VsContainer,
    VsAlert,
  },
  mixins: [clientMixins],
  props: {
    campaignId: String,
  },
  data: () => ({
    privileged: false,
    tabs: ['tracking', { text: 'SEO', value: 'seo' }, 'email', { text: 'url builder', value: 'urlbuilder' }],
    activeTab: 'tracking',
  }),
  computed: mapState({
    processing: state => state.processing,
  }),
  beforeRouteUpdate(to, from, next) {
    this.activeTab = to.name.replace('campaignsMarketing', '').toLowerCase();
    next();
  },
  async created() {
    if (this.hasPrivilege(privileges.CAMPAIGN_MARKETING)) {
      this.privileged = true;
      this.activeTab = this.$route.name.replace('campaignsMarketing', '').toLowerCase();
    } else {
      this.$router.replace('/');
    }
  },
  methods: {
    handleChangeTab(e) {
      this.$router.push({ name: `campaignsMarketing${e.capitalize()}` });
    },
    save() {
      switch (this.activeTab) {
        case 'tracking':
          this.$store.dispatch('updateCurrentCampaignPixels');
          break;
        case 'seo':
          if (!seoValidator.hasErrors()) {
            this.$store.dispatch('updateSeoInfo');
          }
          break;
        case 'email':
          this.$store.dispatch('updateCampaignEmailList');
          break;
      }
    },
  },
};
</script>

<template lang='pug'>
.campaign-marketing(v-if='privileged')
  .vs-container--settings-small(:class='{ "campaign-details--hide-button": activeTab === "urlbuilder" }')
    vs-alert.vs-alert--campaign(
      v-if='campaignEnded',
      no-gutter,
      message='!--- Editing is Disabled ---!',
    )
    vs-container(
      hide-search,
      hide-date,
      title='Marketing',
      button-icon='content-save',
      button-text='save',
      :button-not-visible='campaignEnded || activeTab === `urlbuilder`',
      :button-disabled='campaignEnded || activeTab === `urlbuilder` || processing',
      :tabs='tabs',
      :active-tab='activeTab',
      :processing='processing',
      @container-button-click='save',
      @change-tab='handleChangeTab',
    )
      router-view
</template>

<style>
@import '~import/index';
@import '~styles/index';

.campaign-marketing {
  margin: 0 10px;
  @include mq(mf-sm) {
    margin: 0 50px;
  }
  @include mq(mf-lg) {
    margin: 0 70px;
  }

  .vs-table__title-container {
    border-bottom: 1px solid $borderColor;
  }

  &--hide-button {
    .vs-button {
      visibility: hidden;
    }
  }
}
</style>
